import ReceiptPrinting from './ReceiptPrinting'

export default ReceiptPrinting
